import React from 'react';
import { useLocation } from 'react-router-dom';
import { MultiRouteRenderer } from '@/components/routing/MultiRouteRenderer';
import { useRouteCache } from '@/contexts/RouteCacheContext';

interface RouteContainerProps {
	children?: React.ReactNode;
}

export const RouteContainer: React.FC<RouteContainerProps> = () => {
	return <MultiRouteRenderer />;
};

// Debug component to show cache status
export const RouteCacheDebug: React.FC = () => {
	const location = useLocation();
	const { cachedRoutes } = useRouteCache();

	if (process.env.NODE_ENV !== 'development') {
		return null;
	}

	return (
		<div className="fixed top-16 right-4 z-50 bg-black/80 text-white text-xs p-2 rounded max-w-xs">
			<div className="font-bold mb-1">
				Route Cache ({cachedRoutes.size})
			</div>
			<div className="space-y-1">
				{Array.from(cachedRoutes.entries()).map(([path, route]) => (
					<div
						key={path}
						className={`${route.isActive ? 'text-green-300' : 'text-gray-400'}`}
					>
						{route.isActive ? '●' : '○'} {path}
					</div>
				))}
			</div>
			<div className="mt-1 pt-1 border-t border-gray-600">
				Current: {location.pathname}
			</div>
		</div>
	);
};
